var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22816 11.3356C7.52057 9.75333 8.92774 8.66667 10.4584 8.66667H14.5564C15.1392 8.66667 15.6121 8.16889 15.6121 7.55556V4.22222C15.6121 2.99444 14.6673 2 13.5008 2H6.11129C4.9448 2 4 2.99444 4 4.22222V19.7778C4 21.0056 4.9448 22 6.11129 22H13.5008C14.6673 22 15.6121 21.0056 15.6121 19.7778V16.4444C15.6121 15.8311 15.1392 15.3333 14.5564 15.3333H10.3339C8.38092 15.3333 6.83546 13.4633 7.22816 11.3356Z",
    fill: "url(#paint0_linear_39_28453)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6912 11.2144L19.5243 7.88111C19.1115 7.44667 18.4444 7.44667 18.0316 7.88111C17.6189 8.31556 17.6189 9.01778 18.0316 9.45222L19.3955 10.8889H10.3339C9.75115 10.8889 9.27822 11.3867 9.27822 12C9.27822 12.6133 9.75115 13.1111 10.3339 13.1111H19.3955L18.0306 14.5478C17.6178 14.9822 17.6178 15.6844 18.0306 16.1189C18.2375 16.3356 18.5077 16.4444 18.778 16.4444C19.0482 16.4444 19.3184 16.3356 19.5243 16.1189L22.6912 12.7856C23.1029 12.3511 23.1029 11.6489 22.6912 11.2144Z",
    fill: "url(#paint1_linear_39_28453)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_28453",
    x1: 13.5,
    y1: 2,
    x2: 13.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_28453",
    x1: 13.5,
    y1: 2,
    x2: 13.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2480572caf694e7be7bf8458cfa4c0d5.svg";
export { ForwardRef as ReactComponent };